import {
  useSavedViewConfiguration,
  useSavedViewConfigurationActions,
  useSavedViewConfigurationDirtyState,
} from '../../contexts/views/SavedViewConfigurationProvider'
import {SavedViewOptionsMenu} from './SavedViewOptionsMenu'
import {useSavedViewFields} from './use-saved-view-fields'

interface ConnectedSavedViewOptionsMenuProps {
  basePath: string
  disabled?: boolean
  /** If `true`, each change applies as it is made, and the menu has no Apply or Cancel buttons. */
  applyImmediately?: boolean
}

/** The view options menu, connected to the saved view configuration and its fields. */
export function ConnectedSavedViewOptionsMenu({
  basePath,
  disabled = false,
  applyImmediately = false,
}: ConnectedSavedViewOptionsMenuProps) {
  const {data: fields, isError, isPending} = useSavedViewFields(basePath)
  const configuration = useSavedViewConfiguration()
  const {applyConfiguration, prefetchConfiguration} = useSavedViewConfigurationActions()
  const {dirty, isConfigurationDirty} = useSavedViewConfigurationDirtyState()

  return (
    <SavedViewOptionsMenu
      fields={fields}
      isPending={isPending}
      isError={isError}
      configuration={configuration}
      disabled={disabled}
      showDirtyIndicator={isConfigurationDirty}
      configurationDirty={dirty}
      onApply={applyConfiguration}
      applyImmediately={applyImmediately}
      onIntent={prefetchConfiguration}
    />
  )
}
